import * as routerNames from '@/services/router/router.names'

import MailboxNew from '@/screens/mailbox-new/mailbox-new.vue'
import MailboxHome from '@/screens/mailbox-home/mailbox-home.vue'
import MailboxKanban from '@/screens/mailbox-home/mailbox-kanban.vue'
import ConversationCreate from '@/screens/conversation-create/conversation-create.vue'
import ConversationDetail from '@/screens/conversation-detail/conversation-detail.vue'
import AllConversations from '@/screens/all-conversations/all-conversations.vue'

import MailboxVerificationIntro from '@/screens/mailbox-verification/mailbox-verification-intro.vue'
import MailboxVerificationAutoForwarding from '@/screens/mailbox-verification/mailbox-verification-auto-forwarding.vue'
import MailboxVerificationAutoForwardingTesting from '@/screens/mailbox-verification/mailbox-verification-auto-forwarding-testing.vue'
import MailboxVerificationOutgoingEmail from '@/screens/mailbox-verification/mailbox-verification-outgoing-email.vue'

import MailboxSettingsAssignPeople from '@/screens/mailbox-settings/mailbox-settings-assign-people.vue'
import MailboxSettingsAutoForwarding from '@/screens/mailbox-settings/mailbox-settings-auto-forwarding.vue'
import MailboxSettingsDirectConnection from '@/screens/mailbox-settings/mailbox-settings-direct-connection.vue'
import MailboxSettingsGeneralSettings from '@/screens/mailbox-settings/mailbox-settings-general-settings.vue'
import MailboxSettingsManageWorkflow from '@/screens/mailbox-settings/mailbox-settings-manage-workflow.vue'
import MailboxSettingsWorkflowAutomations from '@/screens/mailbox-settings/mailbox-settings-workflow-automations.vue'
import MailboxSettingsConversationRules from '@/screens/mailbox-settings/mailbox-settings-conversation-rules.vue'
import MailboxSettingsAutoResponder from '@/screens/mailbox-settings/mailbox-settings-auto-responder.vue'
import MailboxSettingsOfficeHours from '@/screens/mailbox-settings/mailbox-settings-office-hours.vue'
import MailboxSettingsChecklistTemplates from '@/screens/mailbox-settings/mailbox-settings-checklist-templates.vue'
import MailboxSettingsCustomFields from '@/screens/mailbox-settings/mailbox-settings-custom-fields.vue'
import MailboxSettingsSavedReplies from '@/screens/mailbox-settings/mailbox-settings-saved-replies.vue'
import MailboxSettingsOutgoingEmail from '@/screens/mailbox-settings/mailbox-settings-outgoing-email.vue'
import MailboxSettingsTicketPortal from '@/screens/mailbox-settings/mailbox-settings-ticket-portal.vue'
import MailboxSettingsIntegrations from '@/screens/mailbox-settings/mailbox-settings-integrations.vue'
import MailboxSettingsEmailSignature from '@/screens/mailbox-settings/mailbox-settings-email-signature.vue'

export default [
  {
    path: '/:accountId/all-conversations',
    name: routerNames.ALL_CONVERSATIONS,
    component: AllConversations,
  },
  {
    path: '/:accountId/mailbox/new',
    name: routerNames.MAILBOX_NEW,
    component: MailboxNew,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/verification',
    name: routerNames.MAILBOX_VERIFICATION_INTRO,
    component: MailboxVerificationIntro,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/verification/auto-forwarding',
    name: routerNames.MAILBOX_VERIFICATION_AUTO_FORWARDING,
    component: MailboxVerificationAutoForwarding,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/verification/auto-forwarding/testing',
    name: routerNames.MAILBOX_VERIFICATION_AUTO_FORWARDING_TESTING,
    component: MailboxVerificationAutoForwardingTesting,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/verification/outgoing-email',
    name: routerNames.MAILBOX_VERIFICATION_OUTGOING_EMAIL,
    component: MailboxVerificationOutgoingEmail,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id',
    name: routerNames.MAILBOX_HOME,
    component: MailboxHome,
  },
  {
    path: '/:accountId/mailbox/:id/kanban',
    name: routerNames.MAILBOX_KANBAN,
    component: MailboxKanban,
  },
  {
    path: '/:accountId/mailbox/:id/conversation/new',
    name: routerNames.CONVERSATION_NEW,
    component: ConversationCreate,
  },
  {
    path: '/:accountId/mailbox/:id/conversation/:childId',
    name: routerNames.CONVERSATION_DETAIL,
    component: ConversationDetail,
  },
  {
    path: '/:accountId/mailbox/:id/settings/assign-people',
    name: routerNames.MAILBOX_SETTINGS_ASSIGN_PEOPLE,
    component: MailboxSettingsAssignPeople,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/auto-forwarding',
    name: routerNames.MAILBOX_SETTINGS_AUTO_FORWARDING,
    component: MailboxSettingsAutoForwarding,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/direct-connection',
    name: routerNames.MAILBOX_SETTINGS_DIRECT_CONNECTION,
    component: MailboxSettingsDirectConnection,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/email-signature',
    name: routerNames.MAILBOX_SETTINGS_EMAIL_SIGNATURE,
    component: MailboxSettingsEmailSignature,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/general-settings',
    name: routerNames.MAILBOX_SETTINGS_GENERAL_SETTINGS,
    component: MailboxSettingsGeneralSettings,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/manage-workflow',
    name: routerNames.MAILBOX_SETTINGS_MANAGE_WORKFLOW,
    component: MailboxSettingsManageWorkflow,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/workflow-automations',
    name: routerNames.MAILBOX_SETTINGS_WORKFLOW_AUTOMATIONS,
    component: MailboxSettingsWorkflowAutomations,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/conversation-rules',
    name: routerNames.MAILBOX_SETTINGS_CONVERSATION_RULES,
    component: MailboxSettingsConversationRules,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/auto-responder',
    name: routerNames.MAILBOX_SETTINGS_AUTO_RESPONDER,
    component: MailboxSettingsAutoResponder,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/office-hours',
    name: routerNames.MAILBOX_SETTINGS_OFFICE_HOURS,
    component: MailboxSettingsOfficeHours,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/checklist-templates',
    name: routerNames.MAILBOX_SETTINGS_CHECKLIST_TEMPLATES,
    component: MailboxSettingsChecklistTemplates,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/custom-fields',
    name: routerNames.MAILBOX_SETTINGS_CUSTOM_FIELDS,
    component: MailboxSettingsCustomFields,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/saved-replies',
    name: routerNames.MAILBOX_SETTINGS_SAVED_REPLIES,
    component: MailboxSettingsSavedReplies,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/outgoing-email',
    name: routerNames.MAILBOX_SETTINGS_OUTGOING_EMAIL,
    component: MailboxSettingsOutgoingEmail,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/ticket-portal',
    name: routerNames.MAILBOX_SETTINGS_TICKET_PORTAL,
    component: MailboxSettingsTicketPortal,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/mailbox/:id/settings/integrations',
    name: routerNames.MAILBOX_SETTINGS_INTEGRATIONS,
    component: MailboxSettingsIntegrations,
    meta: {
      adminOwnerOnly: true,
    },
  },
]
